'use client'

import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from '@/shared/ui/select'
import { Skeleton } from '@/shared/ui/skeleton'
import { SelectionDictionaryParams, dictionaryQueries } from '../../api'
import { SelectProps } from '@radix-ui/react-select'
import { Dictionary } from '../../lib'

interface ComponentProps extends Omit<SelectProps, 'options' | 'value' | 'onValueChange'> {
  dictionary: SelectionDictionaryParams
  placeholder?: string
  valueField?: keyof Dictionary
  labelField?: keyof Dictionary
  value?: Partial<Dictionary>
  onValueChange?(option?: Partial<Dictionary>, value?: string): void
}

export default function Component(props: ComponentProps) {
  const { data, isLoading } = dictionaryQueries.useGet(props.dictionary)
  if (isLoading) return <Skeleton className="w-full h-10" />
  const placeholder = props.placeholder || ''
  return (
    <Select
      value={String(props.value?.[props.valueField || 'id'] || '')}
      onValueChange={(v) => {
        const option = data.find((option) => String(option[props.valueField || 'id']) === v)
        props.onValueChange && props.onValueChange(option, v)
      }}
    >
      <SelectTrigger>
        <SelectValue placeholder={placeholder || 'Выберите'} />
      </SelectTrigger>
      <SelectContent>
        <SelectGroup>
          {data.map((item, key) => (
            <SelectItem key={key} value={String(item[props?.valueField || 'id'])}>
              {item[props?.labelField || 'name']}
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  )
}
